function showBtns() {
  const observer = new MutationObserver(() => {
    const drawerCart = document.querySelector('.drawer--cart');
    const prdDrawerCart = document.querySelector('quick-add-drawer');
    const muiBox = document.querySelector('.MuiButtonBase-root');
    // Support widget launcher: Zendesk renders #launcher, Gorgias renders #gorgias-chat-container
    const iframeExists = document.body.querySelector('#launcher') || document.body.querySelector('#gorgias-chat-container');

    // Check if either drawer is visible
    const drawerCartVisible = drawerCart && drawerCart.getAttribute('aria-hidden') === 'false';
    const prdDrawerCartVisible = prdDrawerCart && prdDrawerCart.getAttribute('aria-hidden') === 'false';
    const isVisible = drawerCartVisible || prdDrawerCartVisible;

    if (muiBox) {
      if (isVisible) {
        muiBox.classList.add('hide-reward_btn');
      } else {
        muiBox.classList.remove('hide-reward_btn');
      }
    }

    if (iframeExists) {
      iframeExists.style.display = isVisible ? 'none' : '';
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
}

showBtns();
